<div class="relative dropdown-container">

  <button (click)="toggle($event)" class="relative">
    <i class="pi pi-bell text-gray-500"></i>
    @if (unreadCount() > 0) {
      <span class="absolute -top-2 -right-2 min-w-[16px] h-4 px-1 flex items-center justify-center text-[10px] font-semibold text-white bg-red-500 rounded-full">
        {{ badgeLabel(unreadCount()) }}
      </span>
    }
  </button>

  @if (layout.isNotificationPanelOpen()) {
    <div class="absolute right-0 mt-2 w-80 max-h-96 flex flex-col bg-white rounded-2xl shadow-lg border z-50">

      <div class="flex items-center justify-between px-4 py-3 border-b border-gray-100">
        <p class="text-sm font-semibold text-gray-800">{{ 'common.notifications.title' | transloco }}</p>
        <div class="flex items-center gap-3">
          <button
            (click)="markAllRead()"
            title="{{ 'common.notifications.markAllRead' | transloco }}"
            class="text-gray-400 hover:text-primary"
          >
            <i class="pi pi-check-square text-sm"></i>
          </button>
          <button
            (click)="clearAll()"
            title="{{ 'common.notifications.clearAll' | transloco }}"
            class="text-gray-400 hover:text-red-500"
          >
            <i class="pi pi-trash text-sm"></i>
          </button>
        </div>
      </div>

      <div class="flex-1 overflow-y-auto">
        @if (items().length === 0 && !loading()) {
          <p class="px-4 py-6 text-center text-sm text-gray-400">
            {{ 'common.notifications.empty' | transloco }}
          </p>
        }

        @for (notification of items(); track notification.uuid) {
          <div
            (click)="onItemClick(notification)"
            class="flex items-start gap-3 px-4 py-3 border-b border-gray-50 hover:bg-gray-50 cursor-pointer"
            [class.bg-blue-50]="!notification.read"
          >
            <i class="pi {{ typeIcon(notification.type) }} text-primary mt-0.5"></i>
            <div class="flex-1 min-w-0">
              <p class="text-xs text-gray-700 line-clamp-2">{{ message(notification) }}</p>
              <p class="text-[11px] text-gray-400 mt-1">{{ notification.createdAt | relativeTime }}</p>
            </div>
            @if (!notification.read) {
              <span class="w-2 h-2 mt-1 rounded-full bg-amber-500 shrink-0"></span>
            }
            <button
              (click)="clearOne($event, notification.uuid)"
              title="{{ 'common.notifications.clearOne' | transloco }}"
              class="text-gray-500 hover:text-gray-700 shrink-0"
            >
              <i class="pi pi-times text-xs"></i>
            </button>
          </div>
        }

        @if (hasMore()) {
          <button
            (click)="loadMore()"
            [disabled]="loading()"
            class="w-full py-2 text-xs text-primary hover:bg-gray-50"
          >
            {{ 'common.notifications.viewMore' | transloco }}
          </button>
        }
      </div>

    </div>
  }

</div>
